import { useState } from 'react'
import { ResponseVariant } from 'workflow/Insights/Insights'

import MainContent from 'features/unifiedFlow/components/MainContent'

import { VariantStatus } from '../manage/utils/variantUtils'

import { VariantLanguageContextProvider } from './context/VariantLanguageContext'
import useElementState from './hooks/useElementState'
import CenterSection from './centerSection'
import LeftSection from './leftSection'
import RightSection from './rightSection'

const Review = () => {
  const [selectedPersonalizationId, setSelectedPersonalizationId] =
    useState<string | undefined>()
  const [variant, setVariant] = useState<ResponseVariant | undefined>()
  const [statusFilter] = useState<VariantStatus>('pending')

  useElementState()

  return (
    <VariantLanguageContextProvider>
      <MainContent className="flex-wrap" id="main-content-page">
        <LeftSection
          onSelectPersonalization={setSelectedPersonalizationId}
          selectedPersonalizationId={selectedPersonalizationId}
          statusFilter={statusFilter}
        />
        <div className="relative flex flex-1">
          <CenterSection
            selectedPersonalizationId={selectedPersonalizationId}
            onSelectPersonalization={setSelectedPersonalizationId}
            onSelectVariant={setVariant}
          />
          <RightSection selectedVariant={variant} />
        </div>
      </MainContent>
    </VariantLanguageContextProvider>
  )
}

export default Review
